import { Link } from "@tanstack/react-router"
import { ChevronRight } from "lucide-react"

interface BreadcrumbItem {
  label: string
  href?: string
}

interface ContentHeaderProps {
  title: string
  description?: string
  breadcrumbs?: BreadcrumbItem[]
  badge?: string
  centered?: boolean
}

export function ContentHeader({
  title,
  description,
  breadcrumbs,
  badge,
  centered = false
}: ContentHeaderProps) {
  return (
    <div className={`mb-12 ${centered ? 'text-center' : ''}`}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className={`flex items-center space-x-1 text-sm text-muted-foreground mb-4 ${centered ? 'justify-center' : ''}`}>
          {breadcrumbs.map((item, index) => (
            <span key={index} className="flex items-center">
              {index > 0 && <ChevronRight className="h-4 w-4 mx-1" />}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground">{item.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      {badge && (
        <div className={`mb-4 ${centered ? 'flex justify-center' : ''}`}>
          <span className="inline-flex items-center rounded-full border bg-background px-3 py-1 text-sm font-medium text-primary">
            {badge}
          </span>
        </div>
      )}

      <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
        {title}
      </h1>

      {description && (
        <p className={`mt-6 text-lg leading-8 text-muted-foreground ${centered ? 'mx-auto max-w-3xl' : 'max-w-3xl'}`}>
          {description}
        </p>
      )}
    </div>
  )
}
